import Image from "next/image";
import React from "react";
import Link from "next/link";

export interface GetInTouchProps {
  title: string;
  label: string;
  mailIcon: string;
  mail: string;
  phoneIcon: string;
  phoneNumber: string;
  scheduleIcon: string;
  schedule: string;
}
export default function GetInTouch({
  title,
  label,
  mailIcon,
  mail,
  phoneIcon,
  phoneNumber,
  scheduleIcon,
  schedule,
}: GetInTouchProps) {
  return (
    <div className="flex flex-col items-start justify-start">
      <h2 className="text-left mb-6 text-2xl">{title}</h2>
      <div className="">
        <p className="mb-4 text-main-black text-base">{label}</p>
        <div className="flex items-start mb-4">
          <Image
            src={mailIcon}
            width={20}
            height={20}
            alt={"icon"}
            className="mt-[2px] mr-2"
          />
          <Link href={`mailto:${mail}`} legacyBehavior>
            <a className="text-main-neutrals text-base">{mail}</a>
          </Link>
        </div>
        <div className="flex items-start mb-4">
          <Image
            src={phoneIcon}
            width={20}
            height={20}
            alt={"icon"}
            className="mt-[1px] mr-2"
          />
          <Link href={`tel:${phoneNumber}`} legacyBehavior>
            <a className="text-main-neutrals text-base">{phoneNumber}</a>
          </Link>
        </div>
        <div className="flex items-start lg:mb-0 mb-4">
          <Image
            src={scheduleIcon}
            width={20}
            height={20}
            alt={"icon"}
            className="mt-[1px] mr-2"
          />
          <p className="text-main-neutrals text-base">{schedule}</p>
        </div>
      </div>
    </div>
  );
}
